import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) {
    // Keep lightweight to avoid side effects; console.error for easy troubleshooting
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught an error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div role="alert" className="p-4 rounded-lg bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-200">
          <p className="font-semibold">Something went wrong.</p>
          <p className="text-sm opacity-80">Check the console for details.</p>
        </div>
      );
    }
    return this.props.children;
  }
}
